export interface Tomo {
  emoji: string
  num: string
  title: string
  desc: string
  outcome: string
}

export interface Bono {
  num: string
  title: string
  desc: string
}

export interface Faq {
  q: string
  a: string
}

/** Precio único del MegaPack, usado en toda la landing. */
export const PRICE_BEFORE = 'AR$29.990'
export const PRICE_NOW = 'AR$9.990'

export const TOMOS: Tomo[] = [
  {
    emoji: '📘',
    num: 'Tomo 1',
    title: 'La Recepcionista Digital',
    desc: 'Bio, perfil, SEO local, destacadas y link de reserva.',
    outcome:
      'Entendé qué tiene que hacer tu Instagram para dejar de publicar sin estrategia.',
  },
  {
    emoji: '📗',
    num: 'Tomo 2',
    title: 'Arquitectura Visual',
    desc: 'Imagen de marca, fotografía en gabinete y branding visual.',
    outcome:
      'Construí un perfil que transmita el mismo profesionalismo que ofrecés en tu gabinete.',
  },
  {
    emoji: '📙',
    num: 'Tomo 3',
    title: 'Ingeniería de Stories',
    desc: 'Conexión diaria, secuencias de stories y venta invisible.',
    outcome:
      'Dejá de subir Stories porque sí y usalas para generar confianza, interacción y consultas.',
  },
  {
    emoji: '📕',
    num: 'Tomo 4',
    title: 'Reels de Alto Valor',
    desc: 'Alcance, autoridad, videos educativos y posicionamiento local.',
    outcome:
      'Creá contenido que muestre tu conocimiento y tus tratamientos sin depender de tendencias absurdas.',
  },
  {
    emoji: '📓',
    num: 'Tomo 5',
    title: 'El Cierre Maestro',
    desc: 'Ventas por DM, protocolo de respuesta y objeciones.',
    outcome:
      'Respondé consultas y conducí la conversación hacia la reserva del turno.',
  },
  {
    emoji: '📔',
    num: 'Tomo 6',
    title: 'El Calendario Pro',
    desc: 'Planificación mensual y 30 días de contenido.',
    outcome:
      'Dejá de preguntarte todos los días "¿qué publico hoy?" y trabajá con un sistema organizado.',
  },
]

export const TOMO_FEATURES: string[] = [
  'Estrategia completa lista para implementar',
  'Ejemplos reales del rubro estética argentino',
  'Scripts y textos listos para copiar y adaptar',
  'Checklists de implementación por capítulo',
  'Tablas, plantillas y sistemas de gestión',
  '100% orientado a convertir seguidores en turnos',
]

export const BONOS: Bono[] = [
  {
    num: '01',
    title: 'El Calendario Pro',
    desc: '30 días de contenido planificados. Todo el mes listo en una mañana.',
  },
  {
    num: '02',
    title: '100 Hooks Estéticos',
    desc: 'Ganchos irresistibles para posts, reels y stories. Listos para usar.',
  },
  {
    num: '03',
    title: 'DM Cierre Pro',
    desc: 'Plantillas de respuesta para consultas, objeciones y cierre de turnos por WhatsApp.',
  },
  {
    num: '04',
    title: 'Auditoría Instagram Pro',
    desc: 'Checklist express para detectar qué está fallando en tu perfil y qué corregir primero.',
  },
]

export const PAIN_POINTS: string[] = [
  'Abrís Instagram y no sabés qué publicar',
  'Terminás subiendo algo solo porque "hay que estar activa"',
  'Publicás promociones cuando quedan huecos en la agenda',
  'Tus tratamientos son profesionales, pero tu perfil no siempre lo transmite',
  'Hacés Stories sin saber qué deberían conseguir',
  'Recibís consultas que preguntan el precio y desaparecen',
  'Sabés de estética, pero nadie te enseñó marketing ni contenido',
]

export const FAQS: Faq[] = [
  {
    q: '¿Sirve aunque tenga pocos seguidores?',
    a: 'Sí. El Tomo 1 optimiza tu perfil para convertir visitas en consultas, sin importar cuántos seguidores tengas.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Acceso inmediato una vez acreditado el pago: recibís un email con el link de descarga. Son PDF listos para leer en celular, tablet o computadora.',
  },
  {
    q: '¿Necesito saber de diseño o de marketing?',
    a: 'No. Está explicado paso a paso en lenguaje simple. Si sabés usar Instagram, podés implementarlo.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no es lo que esperabas, escribís a soporte@creativodigital.shop y te devolvemos el 100%.',
  },
]
